
import axios from "axios";
import config from "./ApiforContext";
import { notification } from "antd";
import OneSignal from "react-onesignal";

const isObject = (value) =>
  typeof value === "object" && !Array.isArray(value) && value !== null;

const handleDefaultNotification = (response) => {
  let type = response.data.success ? "success" : "error";
  let message = response.data.success
    ? "İşlem başarılı."
    : response.data.message;

  notification[type]({
    message: message,
    duration: 3,
  });
};

const handleError = (error, options) => {
  let message = error.toString();


  if (error.response) {
    if (error.response.status === 406) {
      error.response.data.data.forEach((validationMessage) => {
        notification.error({
          message: validationMessage,
          duration: 3,
        });
      });
    } else if (error.response.status === 400) {
      message = isObject(error.response.data)
        ? error.response.data.message
        : error.response.data;

      notification.error({
        message: message,
        duration: 3,
      });
    } else if (error.response.status === 401) {
      RequestHandler.removeUserInfo();
      window.location = "/signin";
      return;
    } else if (error.response.status === 403) {
      if (error.response.data?.message) {
        notification.error({
          message: error.response.data.message,
          duration: 3,
        });
        return;
      } else {
        window.location = "/not-authorized-access";
        return;
      }
    } else if (error.response.status === 500) {
      notification.error({
        message: isObject(error.response.data)
          ? error.response.data.message
          : "Şu anda işleminizi gerçekleştiremiyoruz.Lütfen daha sonra tekrar deneyiniz.",
        duration: 3,
      });
    } else {
      notification.error({
        message: error.response.data?.message
          ? error.response.data.message
          : message,
        duration: 3,
      });
    }
  }

  if (options?.rawResponse) {
    return error;
  }

  return error.response
    ? error.response.data
    : {
      message: message,
      success: false,
    };
};

const handleRequest = (
  endPoint,
  method,
  data,
  showDefaultNotification,
  options
) => {
  let defaultOptions = {
    method: method,
    url: endPoint.startsWith("http") ? endPoint : config.apiUrl + endPoint,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "bearer " + RequestHandler.getToken(),
    },
    data: method !== "get" ? data : undefined,
    params: method === "get" ? data : undefined,
  };

  if (options) {
    defaultOptions = Object.assign(defaultOptions, options);
  }

  return axios
    .request(defaultOptions)
    .then((response) => {
      if (showDefaultNotification && !response.config.url.includes(config.isFinekraLogoApiUrl)) {
        handleDefaultNotification(response);
      }

      return options?.rawResponse ? response : response.data;
    })
    .catch((error) => handleError(error, options));
};

const RequestHandler = {
  send: (endPoint, method, data, showDefaultNotification, options) => {
    const nonAuthUrlPrefixes = [
      "/Auth",
      "/PaymentRequest",
      "/PosCollection",
      "/ConstantPaymentRequest",
    ];
    const isNonAuthEndpoint = nonAuthUrlPrefixes.some((element) =>
      endPoint.toLowerCase().startsWith(element.toLowerCase())
    );

    const expiration = localStorage.getItem("expiration");
    const refreshExpiration = localStorage.getItem("refreshExpiration");
    if (expiration < Date.now() && !isNonAuthEndpoint) {
      if (refreshExpiration < Date.now()) {
        RequestHandler.removeUserInfo();
        window.location = "/signin";
      }

      //send request after refresh token
      return axios
        .request({
          method: "post",
          url: config.apiUrl + "/Auth/RefreshToken",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "bearer " + localStorage.getItem("refreshToken"),
          },
        })
        .then((response) => {
          RequestHandler.setUserInfo(response.data);
          return response;
        })
        .then(() => {
          return handleRequest(
            endPoint,
            method,
            data,
            showDefaultNotification,
            options
          );
        });
    }

    return handleRequest(
      endPoint,
      method,
      data,
      showDefaultNotification,
      options
    );
  },

  get: (endPoint, data, options) =>
    RequestHandler.send(endPoint, "get", data, false, options),

  post: (endPoint, data, showDefaultNotification, options) =>
    RequestHandler.send(
      endPoint,
      "post",
      data,
      showDefaultNotification !== false ? true : false,
      options
    ),

  put: (endPoint, data, showDefaultNotification, options) =>
    RequestHandler.send(
      endPoint,
      "put",
      data,
      showDefaultNotification !== false ? true : false,
      options
    ),

  delete: (endPoint, data, showDefaultNotification, options) =>
    RequestHandler.send(
      endPoint,
      "delete",
      data,
      showDefaultNotification !== false ? true : false,
      options
    ),

  getToken: () => localStorage.getItem("token"),

  setUserInfo: (response) => {
    localStorage.setItem(
      "expiration",
      new Date(response.data.expiration).getTime()
    );
    localStorage.setItem("token", response.data.token);
    localStorage.setItem(
      "refreshExpiration",
      new Date(response.data.refreshTokenExpiration).getTime()
    );
    localStorage.setItem("refreshToken", response.data.refreshToken);
    localStorage.setItem("userId", response.data.userId);
    localStorage.setItem("email", response.data.email);
    localStorage.setItem("tenantId", response.data.tenantId);
    localStorage.setItem("userName", response.data.userName);
  },

  removeUserInfo: () => {
    OneSignal.logout();
    localStorage.removeItem("expiration");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshExpiration");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("email");
    localStorage.removeItem("tenantId");
    localStorage.removeItem("userName");
  },
};

export default RequestHandler;
